import { ROUTES } from "@repo/core/routes";
import Login from "@repo/core/screens/Login";
import { Navigate, Route, Routes } from "react-router-dom";
import { BiometryFinished } from "../pages/Biometry";

export const SignedOutRoutes = () => {
  return (
    <Routes>
      <Route path={ROUTES.login} element={<Login />} />
      <Route path={ROUTES.biometryValidation} element={<BiometryFinished />} />
      <Route path="*" element={<Navigate to={ROUTES.login} />} />
    </Routes>
  );
};
